<template>
  <el-form label-width="140px" class="text-robot-container">
    <el-form-item label="智能客服昵称：">
      <el-input v-model="textForm.nickname" placeholder="请输入智能客服昵称"></el-input>
    </el-form-item>
    <el-form-item label="智能客服头像：">
      <upload-img :img.sync="textForm.avatar"></upload-img>
      <div class="tips">
        建议上传图片尺寸为60px*60px，若不新增则使用校徽做头像
      </div>
    </el-form-item>
    <!-- <el-form-item label="PC轮播图：" class="pc-banner">
      <el-upload
        action="/admin/common/uploader/1"
        list-type="picture-card"
        :headers="headers"
        :limit="5"
        :file-list="textForm.banner"
        :on-exceed="handleExceed"
        :before-upload="beforeAvatarUpload"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </el-form-item> -->
    <el-form-item label="PC展示信息：">
      <editor v-model="textForm.rich_content" useImage width="800px"></editor>
    </el-form-item>
    <el-button type="three" @click="onSave">保存</el-button>
  </el-form>
</template>

<script>
import { isSuccess, getCompletionUrl } from '@/utils';
import { savePcConfig, getPcConfig } from '@/api/setBase';

export default {
  components: {
    'upload-img': () => import('@/components/uploadImg/index.vue'),
    'editor': () => import('@/components/editor/index.vue'),
  },
  data() {
    return {
      textForm: {
        nickname: '',
        avatar: '',
        banner: [],
        rich_content: ''
      },

      headers: {
        token: window.sessionStorage.getItem('token'),
      },
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  mounted() {
    this.getPcConfig();
  },
  watch: {
    textForm(val) {
      console.log('val', val);
    }
  },
  methods: {
    async getPcConfig() {
      const res = await getPcConfig();
      if (res.data) {
        this.textForm = {
          ...res.data,
          banner: res.data.banner ? res.data.banner.map((url) => {
            return {
              url,
            };
          }) : [],
        };
      }
    },
    beforeAvatarUpload(file) {
      let isCorrect = ['png', 'jpg', 'jpeg', 'webp', 'gif'].some((item) => {
        return new RegExp(item).test(file.type);
      });
      if (!isCorrect) {
        this.$message.error('图片格式只能为png, jpg, jpeg, webp, gif');
        return Promise.reject(isCorrect);
      }
      return isCorrect;
    },
    handleRemove(file, fileList) {
      this.textForm.banner = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleExceed() {
      this.$message.error('图片数量超过最大限制');
    },
    handleSuccess(res) {
      if (isSuccess(res.code)) {
        this.textForm.banner.push({ url: getCompletionUrl(res.data.file) });
      }
    },
    async onSave() {
      console.log(this.textForm.rich_content);

      const res = await savePcConfig({
        ...this.textForm,
        banner: this.textForm.banner.map((item) => {
          return item.url;
        }),
      });
      if (isSuccess(res.code)) {
        this.$message.success('保存成功');
      }
    },
  },
};
</script>

<style lang="scss">
.text-robot-container {
  .el-input {
    width: 100%;
    max-width: 300px;
  }

  .avatar-uploader {
    .el-icon-plus:before {
      line-height: 100px;
    }
  }

  .pc-banner {

    .el-upload--picture-card,
    .el-upload-list__item {
      width: 400px;
      height: 200px;
      border-radius: 10px;
    }

    .el-icon-plus {
      line-height: 200px;
    }
  }
}
</style>
